import type { FormErrors } from '@/features/clinic-profile/use-form-state'
import type { Scope } from './api'

/** O formulário do app (novo e aba Permissões), com as mensagens da API: o erro diz o mesmo dos dois lados. */

export interface IntegrationFormState {
  name: string
  description: string
  scopes: Scope[]
}

export const MSG_NAME = 'O nome do app precisa ter de 2 a 60 caracteres.'
export const MSG_SCOPES = 'Escolha pelo menos uma permissão para o app.'
export const MSG_DESCRIPTION = 'A descrição pode ter até 200 caracteres.'

export const INTEGRATION_KEYS = ['name', 'description', 'scopes'] as const

export function validateIntegration(
  values: IntegrationFormState,
): FormErrors<IntegrationFormState> {
  const name = values.name.trim()
  return {
    name: name.length < 2 || name.length > 60 ? MSG_NAME : undefined,
    description: values.description.trim().length > 200 ? MSG_DESCRIPTION : undefined,
    scopes: values.scopes.length === 0 ? MSG_SCOPES : undefined,
  }
}

/** `scopes.0` (um escopo que não existe) também é do campo de permissões. */
export function integrationFieldKey(path: string): keyof IntegrationFormState | undefined {
  const root = path.split('.')[0]
  return root === 'name' || root === 'description' || root === 'scopes' ? root : undefined
}

/** O corpo de `POST`/`PUT /admin/integrations`: aparado, descrição vazia nula, escopos em ordem. */
export function integrationInput(values: IntegrationFormState) {
  return {
    name: values.name.trim(),
    description: values.description.trim() || null,
    scopes: [...values.scopes].sort(),
  }
}

/** O formulário do webhook (criar e alterar). */
export interface WebhookFormState {
  url: string
  description: string
  /** `all`: todos os eventos que o app vê; `some`: os de `events`. */
  mode: 'all' | 'some'
  events: string[]
}

export const MSG_URL =
  'Use um endereço https:// na porta 443, como https://exemplo.com.br/webhooks.'
export const MSG_EVENTS = 'Escolha pelo menos um evento, ou deixe todos.'

export const WEBHOOK_KEYS = ['url', 'description', 'events'] as const

export function validateWebhook(values: WebhookFormState): FormErrors<WebhookFormState> {
  const url = values.url.trim()
  return {
    url: /^https:\/\/[^/?#:@\s]+(:443)?([/?#]|$)/i.test(url) ? undefined : MSG_URL,
    description: values.description.trim().length > 200 ? MSG_DESCRIPTION : undefined,
    events: values.mode === 'some' && values.events.length === 0 ? MSG_EVENTS : undefined,
  }
}

export function webhookFieldKey(path: string): keyof WebhookFormState | undefined {
  const root = path.split('.')[0]
  return root === 'url' || root === 'description' || root === 'events' ? root : undefined
}

export function webhookInput(values: WebhookFormState) {
  return {
    url: values.url.trim(),
    description: values.description.trim() || null,
    events: values.mode === 'all' ? ['*'] : [...values.events].sort(),
  }
}
